import React from 'react';
import './Footer.css';
import { FaFacebookF, FaTwitter, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import LOGO from '../../assets/images/igboezenorthlga.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-wrapper">
        <div className="footer-top">
          <div className="footer-logo">
            <div className='footer-logo-IL'>
              <Link to={'/'}><img src={LOGO} alt='Igbo-Eze North Local Goverment Area' /></Link>
              <Link to={'/'}><h2>Igbo-Eze North</h2></Link>
            </div>

            <p>Empowering community development and good governance.</p>
          </div>
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to={'/'}>Home</Link></li>
              <li><Link to={'/about'}>About</Link></li>
              <li><Link to={'/departments'}>Departments</Link></li>
              <li><Link to={'/contact'}>Contact</Link></li>
              <li><Link to={'/privacy-policy'}>Privacy Policy</Link></li>
            </ul>
          </div>
          <div className="footer-contact">
            <h4>Contact</h4>
            <p>📞 +234 803 897 4288</p>
            <p>📧 info@igboezenorth.en.gov.ng</p>
            <div className="footer-socials">
              <a href="https://www.facebook.com/share/15ZVSBn3xa"><FaFacebookF /></a>
              <a href="https://x.com/igboezenorthlga" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
              <a href="/"><FaInstagram /></a>
              <a href="https://whatsapp.com/channel/0029VaGoHhC3GJP4NAB6Rt1X" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Igbo-Eze North LGA. All rights reserved. Powered by <a href="https://hintcore.com.ng" target="_blank" rel="noopener noreferrer">Hintcore</a>.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;